import React, { useEffect, useState } from "react";
import "rc-slider/assets/index.css";
import {
  Input,
  Row,
  Col,
  Label,
} from "reactstrap";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import Slider, { createSliderWithTooltip } from "rc-slider";
import DeviceButtonGroup from "./DeviceButtonGroup/DeviceButtonGroup";
import './EditorSlider.css'
const SliderWithTooltip = createSliderWithTooltip(Slider);

const def = {
  label: "Margin",
  value: 22,
  defaultValue: 0,
  units: ["px", "em", "rem"],
  activeUnit: "rem",
  onChange: () => null,
  path: ""
};

export const EditorSlider = props => {
  const [fallBackUnit, setFallbackUnit] = React.useState('px')
  const {
    label,
    value,
    units,
    activeUnit,
    onChange,
    path,
    unitChange,
    steps,
    max,
    min,
    attachUnit = false,
    responsiveSettings,
    extraParam = null
  } = props;
  let unitsZ = units.length > 1 && !units.includes('vh') ? [...units, "vh"] : units;
  return (
    <div>
      <Row style={{ margin: "0px" }}>
        <Col style={{ padding: 0, paddingLeft: 10 }}>
          <Label>
            <SystemLabel name={label} />
          </Label>
        </Col>
        {responsiveSettings === true ? <DeviceButtonGroup /> : null}
        <Col
          style={{
            display: "inline-flex",
            padding: 0,
            paddingTop: '4px',
            flexDirection: "row-reverse"
          }}
        >
          {unitsZ.map((u, i) => {
            return (
              <span
                className={activeUnit ? (u === activeUnit ? "active" : "") : (u === fallBackUnit ? "active" : "")}
                style={{
                  fontWeight: activeUnit ? (u === activeUnit ? "bold" : "initial") : (u === fallBackUnit ? "bold" : "initial"),
                  fontSize: "10px",
                  margin: "0px 5px",
                  textTransform: "uppercase",
                  color: activeUnit ? (u === activeUnit ? "#17a2b8" : "darkgray") : (u === fallBackUnit ? "#17a2b8" : "darkgray"),
                  textDecoration: activeUnit ? (u === activeUnit ? "underline" : "initial") : (u === fallBackUnit ? "underline" : "initial"),
                  cursor: "pointer"
                }}
                onClick={() => unitChange(u, path)}
                key={i}
              >
                {u}
              </span>
            );
          })}
        </Col>
      </Row>
      <Row style={{ margin: "0px" }}>
        <Col
          style={{
            maxWidth: "70%",
            padding: "0px",
            paddingLeft: "13px", paddingRight: '11px'
          }}
        >
          <SliderWithTooltip
            value={value}
            defaultValue={0}
            min={min ? min : 0}
            step={steps ? (activeUnit == 'vh' || activeUnit == 'rem' || activeUnit == 'em') ? 0.1 : steps : 1}
            style={{ marginTop: "10px" }}
            max={max ? max : 100}
            onChange={e => {
              if (activeUnit) setFallbackUnit(activeUnit)
              onChange(null, attachUnit ? e + activeUnit : e, path, fallBackUnit)
            }}
          />
        </Col>
        <Col style={{ maxWidth: "30%", padding: "0px", paddingLeft: "10px" }}>
          <Input
            autoComplete="jirango-nofill"
            type="number"
            step={0.1}
            min={min ? min : 0}
            max={max ? max : 100}
            value={value}
            onChange={e => {
              if (activeUnit) setFallbackUnit(activeUnit)

              let value = e.target.value + (!activeUnit ? fallBackUnit : activeUnit);
              console.log('onChange')
              onChange(null, attachUnit ? value : e.target.value, path, fallBackUnit)
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default EditorSlider;
